import CommandChip from './Components/CommandChip';
import StyledCommandChips from './styles';

interface CommandChipsProps {
  commands: {
    command: { id: string; text: string };
    isDetected: boolean;
  }[];
  isForbidden?: boolean;
}

export default function CommandChips(props: CommandChipsProps) {
  const { commands, isForbidden } = props;
  return (
    <StyledCommandChips>
      {commands.map((command) => (
        <CommandChip key={command.command.id} command={command.command.text} isDetected={command.isDetected} isForbidden={isForbidden} />
      ))}
    </StyledCommandChips>
  );
}
